const DEFAULT_TIMEOUT = 2000

export function waitForElement(id, { timeout = DEFAULT_TIMEOUT } = {}) {
  return new Promise((resolve) => {
    const existing = document.getElementById(id)
    if (existing) {
      resolve(existing)
      return
    }

    let timer = null
    const observer = new MutationObserver(() => {
      const el = document.getElementById(id)
      if (el) {
        observer.disconnect()
        clearTimeout(timer)
        resolve(el)
      }
    })
    observer.observe(document.body, { childList: true, subtree: true })

    timer = setTimeout(() => {
      observer.disconnect()
      resolve(null)
    }, timeout)
  })
}
